import { RootState } from '@/store/store';
import { ModuleTree } from 'vuex';
import { coursePackageActions } from '../course-package/course-package.actions';
import { coursePackageGetters } from '../course-package/course-package.getter';
import { coursePackageMutations } from '../course-package/course-package.mutations';
import { coursePackageState } from '../course-package/course-package.state';

export default {
  namespaced: true,
  state: coursePackageState,
  actions: coursePackageActions,
  mutations: coursePackageMutations,
  getters: coursePackageGetters
} as ModuleTree<RootState>;
